import { ArrowRight, Play } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { HERO } from "@/constants/testIds";
import { trackEvent } from "@/lib/analytics";

export default function Hero() {
  const navigate = useNavigate();
  return (
    <section
      id="home"
      className="relative min-h-screen w-full overflow-hidden bg-[#050505]"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_pickle-trainer-v1/artifacts/ljrni2ih_08200C1B-E5B2-409A-B791-067DB4422F1A.PNG"
          alt="Player training with the Pickle Wall™ system in a home garage"
          className="absolute inset-0 w-full h-full object-cover object-center scale-105"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/80 to-[#0a0a0a]/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/55" />
        <div className="absolute inset-0 grain" />
      </div>

      {/* Orange accent corner */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-[#FF6B00] opacity-20 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-32 md:pt-44 pb-24 md:pb-36 min-h-screen flex flex-col justify-center">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-3 mb-8 px-4 py-2 glass rounded-full">
            <span className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse" />
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/80">
              Patent-Pending · Now Available
            </span>
          </div>

          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black uppercase tracking-tight text-white text-balance text-shadow-strong leading-[0.92]">
            Train Anywhere.
            <br />
            Get More <span className="text-[#FF6B00]">Reps.</span>
            <br />
            Play Better.
          </h1>

          <p className="mt-8 max-w-2xl text-lg md:text-xl text-white/80 leading-relaxed">
            Turn unused wall space into your personal pickleball training station. Pickle Wall™ gives players
            a simple way to get more touches, build consistency, and train when a full court isn&apos;t available.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid={HERO.primaryCta}
              onClick={() => {
                trackEvent("cta_click", { button_text: "Shop Pickle Wall", button_location: "hero" });
                navigate("/shop");
              }}
              className="group inline-flex items-center justify-center gap-2 bg-[#FF6B00] hover:bg-[#E66000] text-black font-bold uppercase tracking-wider text-sm px-8 py-4 transition-all hover:orange-glow-strong"
            >
              Shop Pickle Wall — From $249
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
            <button
              data-testid={HERO.secondaryCta}
              onClick={() => {
                trackEvent("cta_click", { button_text: "Explore Pickle Wall Academy", button_location: "hero" });
                navigate("/academy");
              }}
              className="group inline-flex items-center justify-center gap-2 glass text-white font-bold uppercase tracking-wider text-sm px-8 py-4 hover:bg-white/10 transition-colors"
            >
              <Play size={16} className="text-[#FF6B00]" />
              Explore Pickle Wall Academy
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
